<template>
    <DCard
        :title="$t('settings_dns_onehop.provider_type_title')"
        class="mb-3"
        padding
    >
        <DFormRow
            :label="$t('settings_dns_onehop.type')"
            is-required
            :error="form.errors.type"
        >
            <DRadioGroup
                id="onehop_type"
                v-model="form.type"
                :options="dnsProviderOptions"
            />
        </DFormRow>
    </DCard>
    <DCard
        v-if="form.type === 'onehop'"
        :title="$t('settings_dns_onehop.onehop_title')"
        class="mb-3"
        padding
    >
        <DFormRow
            :label="$t('settings_dns_onehop.hostname_url')"
            is-required
            :error="form.errors.url"
        >
            <DInput
                id="onehop_url"
                v-model="form.url"
                :placeholder="$t('settings_dns_onehop.placeholder_hostname')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.username')"
            is-required
            :error="form.errors.username"
        >
            <DInput
                id="onehop_username"
                v-model="form.username"
                :placeholder="$t('settings_dns_onehop.username')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.password')"
            is-required
            :error="form.errors.password"
        >
            <DInput
                id="onehop_password"
                v-model="form.password"
                type="password"
                :placeholder="$t('settings_dns_onehop.password')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.brand')"
            is-required
            :error="form.errors.brand"
        >
            <DInput
                id="onehop_brand"
                v-model="form.brand"
                :placeholder="$t('settings_dns_onehop.brand')"
                maxlength="128"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-show="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ $t('common.connection_successful') }}
                </div>
                <div
                    v-show="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ $t('common.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="$t('common.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
    </DCard>

    <DCard
        v-else-if="form.type === 'vanguard'"
        :title="$t('settings_dns_onehop.vanguard_title')"
        class="mb-3"
        padding
    >
        <DFormRow
            :label="$t('settings_dns_onehop.hostname_url')"
            is-required
            :error="form.errors.url"
        >
            <DInput
                id="vanguard_url"
                v-model="form.url"
                :placeholder="$t('settings_dns_onehop.placeholder_hostname')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.token')"
            is-required
            :error="form.errors.token"
        >
            <DInput
                id="onehop_token"
                v-model="form.token"
                :placeholder="$t('settings_dns_onehop.token')"
                type="password"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.brand')"
            is-required
            :error="form.errors.brand"
        >
            <DInput
                id="onehop_brand"
                v-model="form.brand"
                :placeholder="$t('settings_dns_onehop.brand')"
                maxlength="128"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-show="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ $t('common.connection_successful') }}
                </div>
                <div
                    v-show="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ $t('common.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="$t('common.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
            <DFormRow
                :label="$t('settings_dns_onehop.predefined_nameservers')"
                :error="form.errors.predefined_nameservers"
            >
                <DFormTextarea
                    id="onehop_predefined_nameservers"
                    v-model="form.predefined_nameservers"
                    :placeholder="$t('settings_dns_onehop.placeholder_predefined_nameservers')"
                />
            </DFormRow>
        </DRow>
    </DCard>

    <DCard
        v-else-if="form.type === 'cloudpit'"
        :title="$t('settings_dns_onehop.cloudpit_title')"
        class="mb-3"
        padding
    >
        <DFormRow
            :label="$t('settings_dns_onehop.login_url')"
            is-required
            :error="form.errors.cloudpit_login_url"
        >
            <DInput
                id="cloudpit_login_url"
                v-model="form.cloudpit_login_url"
                :placeholder="$t('settings_dns_onehop.placeholder_login_url')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.api_url')"
            is-required
            :error="form.errors.cloudpit_api_url"
        >
            <DInput
                id="cloudpit_api_url"
                v-model="form.cloudpit_api_url"
                :placeholder="$t('settings_dns_onehop.placeholder_api_url')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.client_id')"
            is-required
            :error="form.errors.cloudpit_client_id"
        >
            <DInput
                id="cloudpit_client_id"
                v-model="form.cloudpit_client_id"
                :placeholder="$t('settings_dns_onehop.client_id')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.client_secret')"
            is-required
            :error="form.errors.cloudpit_client_secret"
        >
            <DInput
                id="cloudpit_client_secret"
                v-model="form.cloudpit_client_secret"
                type="password"
                :placeholder="$t('settings_dns_onehop.client_secret')"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.dns_client_login')"
            is-required
            :error="form.errors.cloudpit_dns_client_login"
        >
            <DInput
                id="cloudpit_dns_client_login"
                v-model="form.cloudpit_dns_client_login"
                :placeholder="$t('settings_dns_onehop.placeholder_dns_client_login')"
                maxlength="255"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-show="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ $t('common.connection_successful') }}
                </div>
                <div
                    v-show="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ $t('common.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="$t('common.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
            <DFormRow
                :label="$t('settings_dns_onehop.predefined_nameservers')"
                :error="form.errors.predefined_nameservers"
            >
                <DFormTextarea
                    id="cloudpit_predefined_nameservers"
                    v-model="form.predefined_nameservers"
                    :placeholder="$t('settings_dns_onehop.placeholder_predefined_nameservers')"
                />
            </DFormRow>
        </DRow>
    </DCard>

    <DCard
        v-else-if="form.type === 'powerdns'"
        :title="$t('settings_dns_onehop.powerdns_title')"
        class="mb-3"
        padding
    >
        <DFormRow
            :label="$t('settings_dns_onehop.hostname_url')"
            is-required
            :error="form.errors.url"
        >
            <DInput
                id="powerdns_url"
                v-model="form.url"
                :placeholder="$t('settings_dns_onehop.placeholder_powerdns_url')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.api_key')"
            is-required
            :error="form.errors.token"
        >
            <DInput
                id="powerdns_token"
                v-model="form.token"
                type="password"
                :placeholder="$t('settings_dns_onehop.api_key')"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_dns_onehop.server_id')"
            is-required
            :error="form.errors.brand"
        >
            <DInput
                id="powerdns_brand"
                v-model="form.brand"
                :placeholder="$t('settings_dns_onehop.placeholder_localhost')"
                maxlength="128"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-show="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ $t('common.connection_successful') }}
                </div>
                <div
                    v-show="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ $t('common.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="$t('common.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
            <DFormRow
                :label="$t('settings_dns_onehop.predefined_nameservers')"
                :error="form.errors.predefined_nameservers"
            >
                <DFormTextarea
                    id="powerdns_predefined_nameservers"
                    v-model="form.predefined_nameservers"
                    :placeholder="$t('settings_dns_onehop.placeholder_predefined_nameservers')"
                />
            </DFormRow>
        </DRow>
    </DCard>

    <DCard
        :title="$t('settings_dns_onehop.additional_settings_title')"
        padding
    >
        <DFormRow
            :label="$t('settings_dns_onehop.allowed_dns_servers')"
            is-required
            :error="form.errors.allowed_dns_servers"
        >
            <DFormTextarea
                id="allowed_dns_servers"
                v-model="form.allowed_dns_servers"
                rows="15"
            />
        </DFormRow>
    </DCard>
    <DFormControls
        :dirty="form.isDirty"
        :disabled="connectionStatus !== 'successful'"
        @submit="submitForm"
    />
</template>

<script setup>
import axios from 'axios'
import { useForm } from '@inertiajs/vue3'
import { ref, watch } from 'vue'

const props = defineProps({
    dnsProviderOptions: {
        type: Array,
        default () {
            return []
        }
    },
    dnsProviderSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    allowedDnsServers: {
        type: String,
        default: null
    }
})

const POWERDNS_DEFAULT_SERVER_ID = 'localhost'

const connectionStatus = ref(null)

const form = useForm({
    type: props.dnsProviderSettings?.type ?? 'vanguard',
    url: props.dnsProviderSettings?.url ?? null,
    username: props.dnsProviderSettings?.username ?? null,
    password: null,
    brand: props.dnsProviderSettings?.brand ?? null,
    token: props.dnsProviderSettings?.token ?? null,
    allowed_dns_servers: props.allowedDnsServers ?? null,
    predefined_nameservers: props.dnsProviderSettings?.predefined_nameservers ?? null,
    cloudpit_login_url: props.dnsProviderSettings?.cloudpit_login_url ?? null,
    cloudpit_api_url: props.dnsProviderSettings?.cloudpit_api_url ?? null,
    cloudpit_client_id: props.dnsProviderSettings?.cloudpit_client_id ?? null,
    cloudpit_client_secret: null,
    cloudpit_dns_client_login: props.dnsProviderSettings?.cloudpit_dns_client_login ?? null
})

const checkConnection = function () {
    form.clearErrors()

    axios.post(route('settings.dns_provider.check-connection', form))
        .then(function () {
            connectionStatus.value = 'successful'
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'

            if (error.response && error.response.data && error.response.data.errors) {
                form.setError(error.response.data.errors)
            }
        })
}

const submitForm = () => {
    form.clearErrors()

    form.post(route('settings.one-hop.store'))
}

watch(() => form.type, function (type) {
    connectionStatus.value = ''

    if (type === 'powerdns' && !form.brand) {
        form.brand = POWERDNS_DEFAULT_SERVER_ID
    }
})
</script>

<style scoped lang="scss">
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}

.green-text {
    color: green;
}
.red-text {
    color: red;
}

</style>
